import { IonContent, IonSkeletonText } from "@ionic/react";
import { FormattedMessage, useIntl } from "react-intl";

import loaderStyles from "@components/loaders/LoaderStyles.module.css";
import styles from "@components/messaging/Messages.module.css";
import TextWithIcon from "@components/text/TextWithIcon";
import Heading2 from "@components/typography/Heading2";

export const ChatsLoader = () => (
  <div className={styles.controlsChats}>
    {Array.from(Array(3)).map(() => (
      <div className={styles.controlsChat} key={Math.random()}>
        <div className={styles.controlsChatHeader}>
          <div className={styles.controlChatUsers}>
            <div className={styles.controlsAvatarsSmall}>
              <IonSkeletonText animated className={loaderStyles.skeletonAvatar30} />
            </div>
            <IonSkeletonText animated className={loaderStyles.skeletonName} />
          </div>
          <IonSkeletonText animated className={loaderStyles.skeletonBodyCopySmall} />
        </div>
        <div className={styles.controlsLastMessage}>
          <IonSkeletonText animated className={loaderStyles.skeletonBodyTwoLines} />
        </div>
      </div>
    ))}
  </div>
);

const MessagesLoader = () => {
  const intl = useIntl();

  return (
    <div>
      <div className={styles.messagesGrid + " " + styles.hideMobile}>
        <div className={styles.controls}>
          <div className={styles.controlsHeader}>
            <Heading2>
              <FormattedMessage id="pages.messages.title" />
            </Heading2>
          </div>
          <div className={styles.controlsSearch}>
            <IonSkeletonText animated className={loaderStyles.skeletonSearch} />
          </div>
          <div className={styles.controlsAllThread}>
            <TextWithIcon
              color="primary"
              icon="messages"
              text={intl.formatMessage({ id: "pages.messages.allThreads" })}
            />
          </div>
          <ChatsLoader />
        </div>
        <div className={styles.chat}>
          <div className={styles.chatHeader}>
            <div className={styles.controlChatUsers}>
              <div className={styles.controlsAvatars}>
                <IonSkeletonText animated className={loaderStyles.skeletonAvatar30} />
              </div>
              <IonSkeletonText animated className={loaderStyles.skeletonH2Small} />
            </div>
          </div>
          <IonContent className={styles.scroll}>
            <div className={styles.chatMessages}></div>
          </IonContent>
          <div className={styles.chatForm}>
            <div className={loaderStyles.spacingTopToolbar}>
              <IonSkeletonText animated className={loaderStyles.skeletonSearch} />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.showMobile}>
        <div className={styles.controls}>
          <div className={styles.controlsHeader}>
            <Heading2 bold>
              <FormattedMessage id="pages.messages.title" />
            </Heading2>
          </div>
          <div className={styles.controlsSearch + " " + loaderStyles.searchSpacing}>
            <IonSkeletonText animated className={loaderStyles.skeletonSearch} />
          </div>
          <div className={styles.controlsAllThread}>
            <TextWithIcon
              color="primary"
              icon="messages"
              text={intl.formatMessage({ id: "pages.messages.allThreads" })}
            />
          </div>
          <ChatsLoader />
        </div>
      </div>
    </div>
  );
};

export default MessagesLoader;
